import { Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import BorderStack from 'components/@common/BorderStack';
import ResponsiveDrawerDialog from 'components/@common/ResponsiveDrawerDialog';

import { useOpenEmailFlow } from './hooks';
import AuthMethod from './steps/AuthMethod';
import CheckInbox from './steps/CheckInbox';
import EmailLink from './steps/EmailLink';

interface Props {
  titleIntlId: string;
  emailSent: boolean;
  afterSignInUrl: string;
  isLoadingEmailLink: boolean;
  originSourceCategory: string;
  onResetEmailFlow: () => void;
}

const AuthenticationCard = ({
  titleIntlId,
  emailSent,
  afterSignInUrl,
  isLoadingEmailLink,
  originSourceCategory,
  onResetEmailFlow,
}: Props) => {
  const { isEmailFlow, handleOpenEmailFlow, handleCloseEmailFlow } =
    useOpenEmailFlow();

  return (
    <BorderStack sx={{ py: 3 }}>
      <Typography
        variant="h6"
        component="h2"
        sx={{
          mb: 3,
        }}
      >
        <FormattedMessage id={titleIntlId} />
      </Typography>
      <AuthMethod
        afterSignInUrl={afterSignInUrl}
        onEmailFlow={handleOpenEmailFlow}
        originSourceCategory={originSourceCategory}
      />
      <ResponsiveDrawerDialog
        isOpen={isEmailFlow}
        onClose={handleCloseEmailFlow}
        onBack={emailSent ? onResetEmailFlow : handleCloseEmailFlow}
        dialogProps={{ maxWidth: 'xs', disablePortal: true }}
        drawerProps={{ disablePortal: true }}
      >
        {!emailSent ? (
          <EmailLink isLoadingEmailLink={isLoadingEmailLink} />
        ) : (
          <CheckInbox afterSignInUrl={afterSignInUrl} />
        )}
      </ResponsiveDrawerDialog>
    </BorderStack>
  );
};

export default AuthenticationCard;
